<template>
    <content-with-side-menu :render-navbar="renderNavbar">
        <template #navbar>
            <community-navbar :hide-login="$route.meta.hideLogin" />
        </template>
        <template #side-menu>
            <!--mq-layout mq="tablet+"-->
            <community-side-menu
                class="is-hidden-mobile"
                @createLink="showInputModal = true"
                @removeLink="deleteLink"
                @updateLinksOrder="updateLinksOrder"
                @updateCircleOrder="updateCircleOrder"
                @openConfiguration="showConfiguration = true"
                @openSettings="showSettings = true"
            />
            <!--/mq-layout-->
        </template>
        <template #main-content>
            <mq-layout mq="mobile">
                <community-top-menu />
            </mq-layout>
            <router-view></router-view>
            <community-modal-resume
                v-if="requiresCodeInput || isAnonymous || !isLoggedIn"
                :community="community"
                @close="
                    showModal = false;
                    community = null;
                "
            />
            <community-configuration
                v-if="showConfiguration"
                @close="showConfiguration = false"
            />
            <community-settings
                v-if="showSettings"
                @close="showSettings = false"
            />
            <input-modal
                v-if="showInputModal"
                v-model="editableValue"
                :component-type="'ritchUrl'"
                :active.sync="showInputModal"
                @input="createLink"
            />
            <community-welcome-modal
                v-if="
                    showWelcome &&
                    !requiresCodeInput &&
                    !isAnonymous &&
                    isLoggedIn
                "
                @close="showWelcome = false"
            />
        </template>
    </content-with-side-menu>
</template>

<script>
import CommunityNavbar from '@/components/CommunityNavbar';
import CommunityTopMenu from '@/components/CommunityTopMenu';
import CommunitySideMenu from '@/components/CommunitySideMenu';
import ContentWithSideMenu from '@/layouts/ContentWithSideMenu';
import CommunityModalResume from '@/components/CommunityModalResume';
import CommunityWelcomeModal from '@/components/CommunityWelcomeModal';
import CommunityConfiguration from '@/components/CommunityConfiguration';
import CommunitySettings from '@/components/CommunitySettings';
import InputModal from '@/components/InputModal';
import {
    updateCommunity,
    removeLink,
    createLink,
    updateLinksOrder,
    updateCircleOrder,
} from '@/services/API';
import _ from 'underscore';
export default {
    components: {
        CommunityNavbar,
        CommunityTopMenu,
        CommunitySideMenu,
        ContentWithSideMenu,
        CommunityModalResume,
        CommunityConfiguration,
        CommunitySettings,
        InputModal,
        CommunityWelcomeModal,
    },
    metaInfo() {
        return {
            title: this.community.title,
            titleTemplate: '%s - Labylok',
            meta: [
                // Twitter Card
                { name: 'twitter:card', content: 'summary' },
                { name: 'twitter:title', content: this.community.title },
                {
                    name: 'twitter:description',
                    content: this.community.description,
                },
                // image must be an absolute path
                { name: 'twitter:image', content: this.communityImageUrl },
                // Facebook OpenGraph
                { property: 'og:title', content: this.community.title },
                { property: 'og:site_name', content: 'Labylok' },
                { property: 'og:type', content: 'website' },
                { property: 'og:image', content: this.communityImageUrl },
                {
                    property: 'og:description',
                    content: this.community.description,
                },
            ],
        };
    },
    props: {
        embed: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showInputModal: false,
            editableValue: undefined,
            showConfiguration: false,
            showSettings: false,
            /*showWelcome: !this.$cookies.isKey(
                'community.dismiss_show_welcome_' +
                    this.$route.params.communityId
            ),*/
            showWelcome: false,
        };
    },
    computed: {
        community() {
            return this.$store.getters.community;
        },
        communityImageUrl() {
            return this.$store.getters.communityImageUrl;
        },
        requiresCodeInput() {
            return (
                this.community.restrictedAccess == true &&
                this.community.accessLevel == 'read'
            );
        },
        renderNavbar() {
            return this.$store.getters.renderNavbar;
        },
        isAnonymous() {
            return this.$store.getters.isAnonymous;
        },
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
    },
    watch: {
        showInputModal() {
            if (!this.showInputModal) {
                this.editableValue = undefined;
                this.editableIndex = undefined;
            }
        },
    },
    mounted() {
        const url = new URL(process.env.VUE_APP_MERCURE_URL);
        url.searchParams.append(
            'topic',
            'http://community.' + this.$route.params.communityId
        );
        this.eventSource = new EventSource(url);
        this.eventSource.onmessage = this.onChangeReceived;
        if (
            this.$route.query.embed ||
            this.$store.getters.renderNavbar == false ||
            localStorage.getItem('vicensUser')
        ) {
            document.body.classList.add('pt-0');
            this.$store.commit('SET_RENDER_NAVBAR', false);
        }
    },
    beforeDestroy() {
        this.eventSource.close();
    },
    destroyed() {
        this.$store.dispatch('cleanCommunity');
        this.$store.commit('SET_RENDER_NAVBAR', true);
    },
    methods: {
        async updateLinksOrder(links) {
            const updateResult = await updateLinksOrder(
                this.community._id,
                links
            );
        },
        async updateCircleOrder(circles) {
            const updateResult = await updateCircleOrder(
                this.community._id,
                circles
            );
            this.community.circles = updateResult.data.circles;
        },
        async deleteLink(link) {
            if (
                confirm(this.$t('Community.delete_link_confirmation_message'))
            ) {
                const updateResult = await removeLink(this.community._id, link);
                this.community.links = updateResult.data.links;
            }
        },
        async createLink(link) {
            const updateResult = await createLink(this.community._id, link);
            console.log(updateResult);
            this.community.links = updateResult.data.links;
            this.showInputModal = false;
        },
        showEditModal({ link, index }) {
            this.editableValue = link;
            this.editableIndex = index;
            this.showInputModal = true;
        },
        onChangeReceived(e) {
            const data = JSON.parse(e.data);
            //console.log(data)
            switch (data.type) {
                case 'NEW_CIRCLE_MESSAGE':
                    if (this.$route.params.id != data.object.circle)
                        this.$store.commit(
                            'INCREMENT_PENDING_MESSAGES',
                            data.object.circle
                        );
                    break;
                case 'ACTIVITY_PUBLISHED':
                    if (data.object.folder != this.$route.params.id) {
                        data.object.viewed = false;
                        this.$store.commit(
                            'INCREMENT_PENDING_ACTIVITIES',
                            data.object
                        );
                    } else {
                        data.object.viewed = true;
                    }
                    if (this.community.accessLevel == 'administrator') {
                        this.$store.commit(
                            'UPDATE_COMMUNITY_ACTIVITY',
                            data.object
                        );
                    } else {
                        this.$store.commit(
                            'ADD_ACTIVITY_TO_COMMUNITY',
                            data.object
                        );
                    }

                    break;
                case 'FEED_MESSAGE_PUBLISHED':
                    if (data.object.status == 'PUBLISHED') {
                        if (this.$route.name != 'community') {
                            this.community.pendingPosts =
                                this.community.pendingPosts + 1;
                        } else {
                            this.$store.commit(
                                'ADD_POST_TO_COMMUNITY',
                                data.object
                            );
                        }
                    }

                    break;
            }
        },
    },
};
</script>

<style scoped lang="scss"></style>
